import React from "react";
import styled from "styled-components";

type Props = {
  handleClick: () => void;
  align: string;
  label: string;
  className?: string;
  fromId: string;
}

export function Button(props: Props) {
  const { align, label, className, handleClick } = props
  return (
    <ButtonContainer
      theme={{
        fontSize: "16px",
        background: "#cc092f",
        align,
      }}
    >
      <button className={className || "primary"} onClick={handleClick}>
        {label}
      </button>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  text-align: ${(props: any) => props.theme.align};

  button.primary {
    background: ${(props: any) => props.theme.background};
    color: white;
    border: none;
    margin-top: 8px;
    border-radius: 4px;
    text-transform: uppercase;
    font-family: ${(props: any) => props.theme.font};
    font-size: ${(props: any) => props.theme.fontSize + "px"};
    letter-spacing: 1px;
  }
`;
